$ = require 'jquery'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
View = require 'view'

module.exports = class BaseDirectoryView extends View
  initialize: ->
    @$reactRoot ?= $('<div></div>')

  renderContent: ->
    throw new Error('BaseDirectoryView renderContent method is not defined.')

  getReactRoot: ->
    React.createElement ReactRootComponent, {}, @renderContent()

  render: ->
    @$el.append(@$reactRoot)
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])
    @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/base-directory-view.coffee